import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../services/firebaseConnection";
import home from "../../assets/icons/bookfuncionario/turn.png";
import lupa from "../../assets/icons/lupa.png";
import "./treinamento.css";

const Treinamento = () => {
  const [buscarTreinamento, setBuscarTreinamento] = useState("");
  const [buscarObra, setBuscarObra] = useState("");
  const [sugestoesTreinamento, setSugestoesTreinamento] = useState([]);
  const [inputFocado, setInputFocado] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [obraFiltroAberto, setObraFiltroAberto] = useState(false);

  const navigate = useNavigate();
  const inputRef = useRef(null);
  const filtroRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        setObraFiltroAberto(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const paginaMain = () => navigate("/main");

  const formatarData = (dataOriginal) => {
    if (!dataOriginal) return "--/--/----";

    try {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dataOriginal)) {
        const [ano, mes, dia] = dataOriginal.split("-");
        return `${dia}/${mes}/${ano}`;
      }

      const dataObj = new Date(dataOriginal);
      if (isNaN(dataObj.getTime())) return "--/--/----";

      return `${String(dataObj.getDate()).padStart(2, "0")}/${String(
        dataObj.getMonth() + 1,
      ).padStart(2, "0")}/${dataObj.getFullYear()}`;
    } catch {
      return "--/--/----";
    }
  };

  const normalizarString = (str) => {
    if (!str) return "";

    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase()
      .trim();
  };

  useEffect(() => {
    const buscarSugestoes = async () => {
      if (buscarTreinamento.length < 1) {
        setSugestoesTreinamento([]);
        return;
      }

      try {
        const matrizesSnapshot = await getDocs(collection(db, "matrizes"));

        const nomesSet = new Set();

        for (const matrizDoc of matrizesSnapshot.docs) {
          const treinamentosSnapshot = await getDocs(
            collection(db, "matrizes", matrizDoc.id, "treinamentos"),
          );

          treinamentosSnapshot.docs.forEach((treinamentoDoc) => {
            const nome = treinamentoDoc.data().nome || "";

            if (
              nome &&
              normalizarString(nome).includes(
                normalizarString(buscarTreinamento),
              )
            ) {
              nomesSet.add(nome);
            }
          });
        }

        const sugestoes = Array.from(nomesSet)
          .sort((a, b) => a.localeCompare(b, "pt-BR"))
          .slice(0, 5);

        setSugestoesTreinamento(sugestoes);
      } catch (error) {
        console.error("Erro ao buscar sugestões:", error);
      }
    };

    buscarSugestoes();
  }, [buscarTreinamento]);

  const buscarFuncionariosComTreinamento = async (
    obraParametro = buscarObra,
    mostrarAlerta = true,
  ) => {
    if (!buscarTreinamento.trim()) {
      if (mostrarAlerta) {
        alert("Digite ou selecione um treinamento.");
      }
      return;
    }

    try {
      setLoading(true);

      const funcionariosSnapshot = await getDocs(
        collection(db, "funcionarios"),
      );

      const funcionariosAtivos = funcionariosSnapshot.docs.filter((doc) => {
        const funcionario = doc.data();
        return funcionario.situacao === "ATIVO";
      });

      const promessas = funcionariosAtivos.map(async (doc) => {
        const funcionario = doc.data();

        const treinamentosSnapshot = await getDocs(
          collection(db, "funcionarios", doc.id, "treinamentos"),
        );

        const treinamentos = treinamentosSnapshot.docs.map((t) => ({
          treinamentoNome: t.data().treinamentoNome || t.data().tipo || "",
          tipo: t.data().tipo || "",
          data: t.data().data,
        }));

        const treinamentoEncontrado = treinamentos.find((t) =>
          normalizarString(t.treinamentoNome).includes(
            normalizarString(buscarTreinamento),
          ),
        );

        const passouFiltroObra =
          obraParametro === "Todas as Obras" ||
          !obraParametro ||
          funcionario.obra === obraParametro;

        if (treinamentoEncontrado && passouFiltroObra) {
          return {
            cpf: doc.id,
            nome: funcionario.nome || "NÃO INFORMADO",
            funcao: funcionario.funcao || "NÃO INFORMADO",
            obra: funcionario.obra || "NÃO INFORMADO",
            situacao: funcionario.situacao || "",
            treinamentoAtual: treinamentoEncontrado,
          };
        }

        return null;
      });

      const listaResultados = (await Promise.all(promessas))
        .filter(Boolean)
        .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

      setResultados(listaResultados);

      if (mostrarAlerta && listaResultados.length === 0) {
        alert("Nenhum resultado encontrado.");
      }
    } catch (error) {
      console.error("Erro na busca:", error);
      alert("Ocorreu um erro na busca");
    } finally {
      setLoading(false);
    }
  };

  const selecionarSugestao = (sugestao) => {
    setBuscarTreinamento(sugestao);
    setSugestoesTreinamento([]);
    inputRef.current?.blur();
  };

  const [obras, setObras] = useState(["Todas as Obras"]);

  useEffect(() => {
    const buscarObras = async () => {
      try {
        const snapshot = await getDocs(
          query(collection(db, "obras_atuais"), orderBy("nome")),
        );

        const listaObras = snapshot.docs
          .map((doc) => doc.data().nome)
          .filter(Boolean);

        setObras(["Todas as Obras", ...listaObras]);
      } catch (error) {
        console.error("Erro ao buscar obras:", error);
      }
    };

    buscarObras();
  }, []);

  const selecionarObra = async (obra) => {
    const obraSelecionada = obra === "Todas as Obras" ? "" : obra;

    setBuscarObra(obraSelecionada);
    setObraFiltroAberto(false);

    if (buscarTreinamento.trim()) {
      await buscarFuncionariosComTreinamento(obraSelecionada, false);
    }
  };

  const handleBuscaChange = (e) => {
    const valor = e.target.value.toUpperCase();

    setBuscarTreinamento(valor);

    if (!valor.trim()) {
      setResultados([]);
      setBuscarObra("");
      setSugestoesTreinamento([]);
      setObraFiltroAberto(false);
    }
  };

  return (
    <div className="container-treinamento">
      {loading && <div className="loading-overlay">Carregando...</div>}

      <div className="container-treinamento-I">
        <div className="container-treinamento-II">
          <div className="search-wrapper">
            <div className="search-treinamento-T">
              <input
                ref={inputRef}
                type="text"
                placeholder="Buscar Treinamento"
                value={buscarTreinamento}
                onChange={handleBuscaChange}
                onFocus={() => setInputFocado(true)}
                onBlur={() => setTimeout(() => setInputFocado(false), 150)}
                onKeyDown={(e) =>
                  e.key === "Enter" && buscarFuncionariosComTreinamento()
                }
              />

              <img
                src={lupa}
                alt="Buscar"
                onClick={() => buscarFuncionariosComTreinamento()}
                style={{ cursor: "pointer" }}
              />

              {inputFocado && sugestoesTreinamento.length > 0 && (
                <ul className="dropdown-treinamentos">
                  {sugestoesTreinamento.map((item, index) => (
                    <li
                      key={index}
                      onMouseDown={() => selecionarSugestao(item)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="filtro-obra-wrapper" ref={filtroRef}>
            <div
              className="filtro-obra-trigger"
              onClick={() => setObraFiltroAberto((prev) => !prev)}
            >
              {buscarObra || "Todas as Obras"}
              <span
                className={`arrow ${obraFiltroAberto ? "up" : "down"}`}
              ></span>
            </div>

            {obraFiltroAberto && (
              <div className="filtro-obra-dropdown">
                {obras.map((obra, index) => (
                  <div
                    key={index}
                    className={`filtro-obra-item ${
                      buscarObra === (obra === "Todas as Obras" ? "" : obra)
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => selecionarObra(obra)}
                  >
                    {obra}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="info-treinamento">
          <div className="resultados-container">
            {resultados.length > 0 ? (
              <div className="lista-colunas-wrapper">
                <div className="cabecalho-lista-treinamento">
                  <p className="col-nome">NOME</p>
                  <p className="col-funcao">FUNÇÃO</p>
                  <p className="col-obra">OBRA</p>
                  <p className="col-data">REALIZADO EM</p>
                </div>

                <div className="scroll-container-lista">
                  {resultados.map((item, index) => (
                    <div className="linha-resultado" key={index}>
                      <p className="col-nome">{item.nome}</p>
                      <p className="col-funcao">{item.funcao}</p>
                      <p className="col-obra">{item.obra}</p>
                      <p className="col-data">
                        {formatarData(item.treinamentoAtual?.data)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="estado-vazio">
                <p>Busque por um treinamento para ver os resultados</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="icon-home-treinamento">
        <img onClick={paginaMain} src={home} alt="Página inicial" />
      </div>
    </div>
  );
};

export default Treinamento;
